export default function UploadIcon({
    width,
    height,
}: {
    width: string | number
    height: string | number
}) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 17 21"
            fill="current"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.7857 16C15.4637 16 15.1547 16.1317 14.927 16.3661C14.6994 16.6004 14.5714 16.9185 14.5714 17.25V18.5H2.42857V17.25C2.42857 16.8033 2.1971 16.3906 1.82143 16.1674C1.44576 15.9442 0.982808 15.9442 0.607143 16.1674C0.231478 16.3906 0 16.8033 0 17.25V19.75C0 20.0815 0.127937 20.3996 0.355612 20.6339C0.583287 20.8683 0.892285 21 1.21429 21H15.7857C16.1077 21 16.4167 20.8683 16.6444 20.6339C16.8721 20.3996 17 20.0815 17 19.75V17.25C17 16.9185 16.8721 16.6004 16.6444 16.3661C16.4167 16.1317 16.1077 16 15.7857 16Z"
                fill="current"
            />
            <path
                d="M5.04189 7.56746L7.2628 4.96292V14.5449C7.2628 15.0649 7.49864 15.5453 7.88141 15.8051C8.26417 16.065 8.73586 16.065 9.11862 15.8051C9.50138 15.5453 9.73723 15.0649 9.73723 14.5449V4.96292L11.9581 7.56746C12.2766 7.88836 12.7115 7.99749 13.1136 7.85783C13.5157 7.71784 13.8303 7.3479 13.9493 6.87502C14.068 6.40211 13.9752 5.89054 13.7024 5.51604L9.37213 0.423208C9.14043 0.152003 8.82699 0 8.5 0C8.17302 0 7.85957 0.152003 7.62787 0.423208L3.29761 5.51604C3.02475 5.89053 2.93196 6.40207 3.05072 6.87502C3.16974 7.34792 3.48429 7.71789 3.88637 7.85783C4.28846 7.99749 4.72343 7.88836 5.04186 7.56746H5.04189Z"
                fill="current"
            />
        </svg>
    );
}
